import type { BreadcrumbLinkProps } from '@/components/Breadcrumbs/types';
import type { CategoryHeader } from '@/utils/pages/api';

export const getCurrentBreadcrumb = ({
  data,
}: {
  data: CategoryHeader;
}): BreadcrumbLinkProps => {
  const result = {
    id: data.id.toString() ?? data.url,
    label: data.breadcrumb_name ?? data.name,
    slug: data.slug,
    relative_url: data.url,
  };

  return result;
};
